(function($){

	OH.settings.standbyDefine = (function(){
		var define = new Object();
		
		define.partners = function($element){
			OH.settings.xfadeControl.patternedCrossFade($element);
		};
		
		return define;
	})();
})(jQuery);
